import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-success',
  templateUrl: './icon-success.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSuccessComponent {}
